import React from "react";

function Banner(){
    return(
        <div className="container-fill flex my-32 mx-20 bg-blue-700 items-center justify-center text-6xl font-bold text-white h-80 rounded-3xl">
            BANNER PROMO
        </div>
    );
};
export default Banner;